import { classNames } from '@/util/tailwindHelpers'
import React, { PropsWithChildren } from 'react'
import { Pin as PinType } from './types'
import Pin from './Pin'

interface Props extends PropsWithChildren {
  pins: {
    className?: string
    items: PinType[]
  }
  className?: string
}

export default function PinElements({ children, className, pins }: Props) {
  return (
    <div className={classNames('relative', className)}>
      {pins.items.map((pin, index) => (
        <Pin key={index} {...pin} className={pins.className} />
      ))}
      {children}
    </div>
  )
}
